module.exports = __webpack_public_path__ + "static/media/Left@3x.5fcdc5c4.png";